import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: PaginacaoListagem(['id'], 5, 'DESC'),
	datasource: [],
	totalElements: 0,
	totalPages: 0,
}
